/**
 * Módulo del mapa de calor (#43). El contrato está en `routes/module.ts`.
 *
 * `viewer` alcanza: el mapa muestra agregados con supresión por k-anonimato
 * aplicada en el servidor, así que no hay nada acá que un rol de lectura no
 * pueda ver. La API valida el rol igual en cada request.
 */
import type { ModuleRoutes } from '../module';
import { MapPage } from './MapPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'map',
  minimumRole: 'viewer',
  routes: [{ path: '', element: <MapPage /> }],
};
